export default __webpack_public_path__ + "static/media/smartsearchbanner.6710bf14.jpg";